<template lang="html">
  <div class="_sidebarbg">
    <div class="sticky-top _sidebarbg__navlink">
      <div class="w-100 button__shipment">
        <router-link id="tooltip-saf" to="/request-shipment-type">
          <!-- <button type="button" class="mt-2 button__deepred" v-if="(profile.status === 'ANDALINVERIFICATION')" :disabled="buttonDisabled" >Shipment</button> -->
          <button
            type="button"
            class="mt-2 button__deepred"
            v-if="profile.status === 'ANDALINVERIFICATION'"
          >
            <img src="@/assets/image/icon/add-shipment.svg" alt="" />
            <span>Order</span>
          </button>
        </router-link>
        <b-tooltip
          v-if="companyStatusSAF !== 'APPROVED' && companyStatus"
          id="andalin-saf"
          show
          target="tooltip-saf"
          placement="rightbottom"
        >
          Our company policy requires SAF prior to any shipment. Please ensure
          that you have signed our SAF in hardcopy. We reserve the right to
          cancel your quotation if we found that you have not provided proper
          SAF to us.
        </b-tooltip>
      </div>
      <div class="_sidebarbg__navlink--list">
        <div
          class="_sidebar__top global__scrollcustom"
          :style="
            profile.status === 'ANDALINVERIFICATION'
              ? 'height: 80%;'
              : 'height: 88%;'
          "
        >
          <div>
            <div v-for="(item, index) in listMenu" :key="index">
              <div
                v-if="item.title !== 'Settings' && item.title !== 'Warehouse'"
              >
                <router-link :to="item.link" v-if="isShow(item.title)">
                  <li class="row menu-item" :class="index === 0 && 'active'">
                    <div class="col-sm-2">
                      <img :src="item.icon" alt="" />
                    </div>
                    <div class="col-sm-10 __minppding">
                      <a href="" class="__navlink">{{ item.title }}</a>
                    </div>
                  </li>
                </router-link>
              </div>
              <div v-else-if="item.title === 'Settings'">
                <div
                  v-if="isShow(item.title)"
                  v-b-toggle.collapse-settings
                  style="cursor: pointer;"
                >
                  <li class="row menu-item" :class="index === 0 && 'active'">
                    <div class="col-sm-2">
                      <img :src="item.icon" alt="" />
                    </div>
                    <div class="col-sm-10 __minppding">
                      <p class="__navlink">{{ item.title }}</p>
                    </div>
                  </li>
                </div>
              </div>
              <div v-else>
                <div
                  v-if="isShow(item.title)"
                  v-b-toggle.collapse-warehouse
                  style="cursor: pointer;"
                >
                  <li class="row menu-item" :class="index === 0 && 'active'">
                    <div class="col-sm-2">
                      <img :src="item.icon" alt="" />
                    </div>
                    <div class="col-sm-10 __minppding">
                      <p class="__navlink">{{ item.title }}</p>
                    </div>
                  </li>
                </div>
              </div>
              <b-collapse
                :id="
                  item.title === 'Settings'
                    ? 'collapse-settings'
                    : 'collapse-warehouse'
                "
              >
                <div v-for="(child, index) in item.children" :key="index">
                  <router-link :to="child.link">
                    <li
                      class="row menu-item pl-4"
                      :class="index === 0 && 'active'"
                    >
                      <div class="col-sm-2">
                        <img :src="child.icon" alt="" />
                      </div>
                      <div class="col-sm-10 __minppding">
                        <a href="" class="__navlink">{{ child.title }}</a>
                      </div>
                    </li>
                  </router-link>
                </div>
              </b-collapse>
            </div>
          </div>
          <!-- <div class="row pl-3 pt-1" :class="{ 'bottom_position' : profile.codeUserType === 'GUEST' }"> -->
          <div class="row pl-3 pt-1">
            <div class="col-sm-2 pr-0">
              <img src="@/assets/image/icon/sb-support.svg" alt="" />
            </div>
            <div class="col-sm-10" style="padding-left:7px">
              <p class="contact__text">Contact Our Sales</p>
              <p class="contact__text"><b>(021) 3970 8070</b></p>
            </div>
          </div>
        </div>
        <div class="_sidebar__bottom">
          <div class="col-md-12 __term">
            <a @click.prevent="terms()" href="#">Terms &amp; Conditions</a> and
            <br />
            <a @click.prevent="policy()" href="#">Privacy Policy</a>
          </div>
          <div class="_sidebar__footer">
            <p>
              &#x24B8; 2016 - {{ currentYear }} Andalin (PT. Eximku Logistik
              Indonesia)
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'Sidebar',
  data() {
    return {
      buttonDisabled: true,
      companyStatus: '',
      companyStatusSAF: '',
      currentYear: moment().format('YYYY'),
      listMenu: [
        {
          title: 'Home',
          icon: require('@/assets/image/icon/sb-home.svg'),
          link: '/dashboard'
        },
        // {
        //   title: 'Vessel Schedule',
        //   icon: require('@/assets/image/icon/sb-vessel-schedule.svg'),
        //   link: '/vessel-schedule'
        // },
        {
          title: 'Manage Shipment',
          icon: require('@/assets/image/icon/sb-shipment.svg'),
          link: '/manage-shipment/ongoing'
        },
        {
          title: 'Request List',
          icon: require('@/assets/image/icon/sb-request.svg'),
          link: '/request-list/rfq'
        },
        {
          title: 'Warehouse',
          icon: require('@/assets/image/icon/cube.svg'),
          children: [
            {
              title: 'Inbound',
              icon: require('@/assets/image/icon/clipboard-list.svg'),
              link: '/warehouse-list/waiting-inbound'
            },
            {
              title: 'Inventory',
              icon: require('@/assets/image/icon/clipboard-check.svg'),
              link: '/inventory-list/in-storage'
            }
          ]
        },
        {
          title: 'Help Center',
          icon: require('@/assets/image/icon/sb-faq.svg'),
          link: '/help'
        },
        {
          title: 'Settings',
          icon: require('@/assets/image/icon/sb-setting.svg'),
          children: [
            {
              title: 'My Account',
              icon: require('@/assets/image/icon/sb-account.svg'),
              link: '/settings/myaccount'
            },
            {
              title: 'My Address',
              icon: require('@/assets/image/icon/sb-addresses.svg'),
              link: '/settings/myaddresses'
            },
            {
              title: 'My Documents',
              icon: require('@/assets/image/icon/sb-documents.svg'),
              link: '/settings/mydocuments'
            }
          ]
        },
        {
          title: 'My Account',
          icon: require('@/assets/image/icon/sb-account.svg'),
          link: '/settings/myaccount'
        },
        {
          title: 'My Documents',
          icon: require('@/assets/image/icon/sb-documents.svg'),
          link: '/settings/mydocuments'
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      profile: 'auth/profile',
      getCredit: 'dashboard/getCredit',
      company: 'settingCompany/company'
    })
  },
  async mounted() {
    await this.fetchCompanyProfile();
  },
  methods: {
    terms: function() {
      this.$eventHub.$emit('dialog-rule-terms-accepted');
    },
    policy: function() {
      this.$eventHub.$emit('dialog-rule-policy-accepted');
    },
    getShipmentTitle() {
      return this.profile.codeUserType === 'GUEST'
        ? 'Shipment'
        : 'Manage Shipment';
    },
    async fetchCompanyProfile() {
      await this.$store.dispatch('settingCompany/FETCH_COMPANY').then(() => {
        if (this.company) {
          this.companyStatus = this.company.status;
          this.companyStatusSAF = this.company.saf.status;
          if (this.profile.status === 'ANDALINVERIFICATION') {
            this.fetchCredit();
          }
        }
      });
    },
    async fetchCredit() {
      await this.$store.dispatch('dashboard/FETCH_CREDIT').then(() => {
        if (this.companyStatus) {
          if (this.companyStatusSAF === 'APPROVED') {
            if (
              this.getCredit.credits.creditBalance < 0 &&
              this.getCredit.credits.creditBalance === 0
            ) {
              this.buttonDisabled = true;
            } else if (
              !this.getCredit.credits.creditBalance === 0 &&
              this.getCredit.credits.creditLimit === 0
            ) {
              this.buttonDisabled = false;
            } else {
              this.buttonDisabled = false;
            }
          } else {
            this.buttonDisabled = true;
          }
        } else {
          this.buttonDisabled = false;
        }
      });
    },
    isShow(title) {
      let show = false;
      if (this.profile) {
        if (title === 'Shipment' || title === 'Manage Shipment') {
          show =
            this.profile.status === 'ANDALINVERIFICATION' ||
            this.profile.codeUserType === 'GUEST';
        } else if (title === 'My Account' || title === 'My Documents') {
          show =
            this.profile.status === 'USERVERIFICATION' ||
            this.profile.status === 'SALESVERIFICATION';
        } else {
          show = this.profile.status === 'ANDALINVERIFICATION';
        }
      }
      return show;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/global/Sidebar.vue